import axiosInstance from "../services/axiosInstance";
import * as Endpoints from "../entities/Endpoints";

export const fetchWorkoutPlan = async ({
  clientId,
  coachId,
  coachWorkoutPlanId,
}) => {
  const params = {
    clientId: clientId,
    coachId: coachId,
    clientWorkoutPlanId: coachWorkoutPlanId,
  };
  try {
    const response = await axiosInstance.get(`${Endpoints.GET_WORKOUT_PLAN}`, {
      params,
    });
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.message || "Failed to fetch workout plan detail"
    );
  }
};

export const postWorkoutPlan = async ({ payload }) => {
  try {
    const response = await axiosInstance.post(
      `${Endpoints.POST_WORKOUT_PLAN}`,
      payload
    );
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data || "Failed to fetch workout plan detail"
    );
  }
};

export const deleteWorkoutPlan = async ({
  clientId,
  coachWorkoutPlanId,
}) => {
  const params = {
    clientId: clientId,
    clientWorkoutPlanId: coachWorkoutPlanId,
  };
  try {
    const response = await axiosInstance.delete(`${Endpoints.DELETE_WORKOUT_PLAN}`, {
      params,
    });
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.message || "Failed to delete workout plan "
    );
  }
};

